import { render, staticRenderFns } from "./NewsTableComponent.vue?vue&type=template&id=62683ceb&"
import script from "./NewsTableComponent.vue?vue&type=script&lang=js&"
export * from "./NewsTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports